export async function waitUntil<T> (evaluate: () => T | null | undefined | false, interval = 200, maxWaitMs = 10000): Promise<T> {
  let handler: number
  let counter = 0
  let done = false
  const promise = new Promise<T>((resolve, reject) => {
    const initValue = evaluate()
    if (initValue != null && initValue !== false) {
      resolve(initValue); return
    }
    handler = window.setInterval(() => {
      if (done) return
      const value = evaluate()
      if (value != null && value !== false) {
        done = true
        window.clearInterval(handler)
        resolve(value)
      }
      counter += interval
      if (counter >= maxWaitMs) {
        done = true
        window.clearInterval(handler)
        reject(new Error('waitUntil timeout'))
      }
    }, interval)
  })
  return await promise
}
